import { memo } from 'react';
import { useSelector } from 'react-redux';

import { PlayerTimeButton, PlayerTimeFormatButton } from '@air/component-player';

import {
  centralizedClipDurationSelector,
  centralizedClipFPSSelector,
  centralizedClipFrameCountSelector,
} from '~/store/centralizedClip/selectors';

export const AssetModalContentFooterVideoTimeControls = memo(() => {
  const clipFps = useSelector(centralizedClipFPSSelector);
  const clipDuration = useSelector(centralizedClipDurationSelector);
  const clipFrameCount = useSelector(centralizedClipFrameCountSelector);

  return (
    <div className="flex items-center gap-2">
      <PlayerTimeButton fps={clipFps} seekDirection="backward" step={1} />
      <PlayerTimeFormatButton duration={clipDuration} frameCount={clipFrameCount} />
      <PlayerTimeButton fps={clipFps} seekDirection="forward" step={1} />
    </div>
  );
});

AssetModalContentFooterVideoTimeControls.displayName = 'AssetModalContentFooterVideoTimeControls';
